module.exports = __webpack_public_path__ + "img/game2.3f8a5624.png";